/* tslint:disable */
import { SupportedLanguage } from '../../../../utils/i18n'
import { Supplier } from '../../suppliers/data'

/* Self defined interfaces for Supplier */

export interface SupplierDetail
  extends Omit<Supplier, 'Support' | 'DelForProcess' | 'OrderProcess'> {
  EmailSettings: EmailSettings
  WebEdiSettings: WebEdiSettings
  HasChangesPending?: boolean
}

export interface SupplierDetailWithTemaplate
  extends Omit<SupplierDetail, 'EmailSettings' | 'WebEdiSettings'> {
  Template: string
  EmailSettings?: EmailSettings
  WebEdiSettings?: WebEdiSettings
}

export interface EmailSettings {
  Inbound: OverridableSetting<string>
  Outbound: OverridableSetting<string>
  Support: OverridableSetting<string>
}

export interface WebEdiSettings {
  DeliveryProcessForecastSettings: DeliveryProcessForecastSettings
  EmailLanguage: OverridableSetting<SupportedLanguage>
  OrderProcessSettings: OrderProcessSettings
  EInvoiceLanguage: OverridableSetting<SupportedLanguage>
  EInvoiceProcessSettings: EInvoiceProcessSettings
}

export type DeliveryForecastProcessCompletions =
  | 'confirmation'
  | 'despatchadvice'
  | 'despatchadvice_with_confirmation'

export interface DeliveryProcessForecastSettings {
  IsProcessActive: OverridableSetting<boolean>
  ProcessCompletions: OverridableSetting<DeliveryForecastProcessCompletions>
  ResponsePeriod: OverridableSetting<number>
}

export type OrderProcessCompletions =
  | 'orderresponse'
  | 'despatchadvice'
  | 'invoice'

export type InvoiceFormats =
  | 'sap_idoc'
  | 'joubini_ibi'
  | 'zugferd'
  | 'insiders'
  | 'custom'

export interface OrderProcessSettings {
  DeliveryDateDeviation?: OverridableSetting<number | null>
  IsProcessActive: OverridableSetting<boolean>
  ProcessCompletions?: OverridableSetting<OrderProcessCompletions>
  ResponsePeriod?: OverridableSetting<number>
  InvoiceFormat: OverridableSetting<InvoiceFormats>
  AllowPreliminaryConfirmation: OverridableSetting<boolean>
}

export enum EInvoicePartnerType {
  Vendor = 0,
  LogicalSystem = 1,
}

export interface EInvoiceProcessSettings {
  EInvoicePartnerType: OverridableSetting<EInvoicePartnerType>
  IsProcessActive: OverridableSetting<boolean>
  IsEInvoiceSupplierEnabled: OverridableSetting<boolean>
  EInvoiceAttachmentDocumentType: OverridableSetting<number>
}

export interface SupplierTemplate {
  id: string
  name: string
  description: string
  isdefault: boolean
  changedat: Date
  changedby: string
  isstandard: boolean
}

export interface OverridableSetting<TValue> {
  OverrideDefaultValue: boolean
  Value: TValue
}

// Formik edit supplier dto
export interface EditSupplierFormDto {
  status: SupplierDetail['Status']
  hasChangesPending: SupplierDetail['HasChangesPending']
  id: SupplierDetail['Id']
  name: SupplierDetail['Name']
  description: SupplierDetail['Description']
  supportValue: string
  orderIsProcessActiveValue: boolean
  orderIsProcessActiveOverride: boolean
  orderProcessCompletionsValue: OrderProcessCompletions
  orderProcessCompletionsOverride: boolean
  orderResponsePeriodValue: number
  orderResponsePeriodOverride: boolean
  orderDeliveryDateDeviationValue: number | null
  orderDeliveryDateDeviationOverride: boolean
  orderInvoiceFormatValue: InvoiceFormats
  orderInvoiceFormatOverride: boolean
  orderAllowPreliminaryConfirmationValue: boolean
  orderAllowPreliminaryConfirmationOverride: boolean
  deliveryForecastIsProcessActiveValue: boolean
  deliveryForecastIsProcessActiveOverride: boolean
  deliveryForecastProcessCompletionsValue: DeliveryForecastProcessCompletions
  deliveryForecastProcessCompletionsOverride: boolean
  deliveryForecastResponsePeriodValue: number
  deliveryForecastResponsePeriodOverride: boolean
  eInvoiceLanguageValue: SupportedLanguage
  eInvoiceLanguageOverride: boolean
  eInvoicePartnerTypeValue: EInvoicePartnerType
  eInvoicePartnerTypeOverride: boolean
  eInvoiceIsProcessActiveValue: boolean
  eInvoiceIsProcessActiveOverride: boolean
  isEInvoiceSupplierEnabledValue: boolean
  isEInvoiceSupplierEnabledOverride: boolean
  eInvoiceAttachmentDocumentTypeValue: number
  eInvoiceAttachmentDocumentTypeOverride: boolean
  inboundValue: string
  outboundValue: string
  emailLanguageValue: SupportedLanguage
  emailLanguageOverride: boolean
}

// Formik add supplier dto
export interface AddSupplierFormDto
  extends Pick<
    EditSupplierFormDto,
    | 'id'
    | 'name'
    | 'description'
    | 'supportValue'
    | 'inboundValue'
    | 'outboundValue'
  > {
  template: string
}
